export const Resources ={
    bjx: [
        {name:'bjx_1',url:require('../assets/images/frames/bjx/bjx_1.png')},
        {name:'bjx_2',url:require('../assets/images/frames/bjx/bjx_2.png')},
        {name:'bjx_3',url:require('../assets/images/frames/bjx/bjx_3.png')},
        {name:'bjx_4',url:require('../assets/images/frames/bjx/bjx_4.png')},
        {name:'bjx_5',url:require('../assets/images/frames/bjx/bjx_5.png')},
        {name:'bjx_6',url:require('../assets/images/frames/bjx/bjx_6.png')},
        {name:'bjx_7',url:require('../assets/images/frames/bjx/bjx_7.png')},
        {name:'bjx_8',url:require('../assets/images/frames/bjx/bjx_8.png')},
        {name:'bjx_9',url:require('../assets/images/frames/bjx/bjx_9.png')},
        {name:'bjx_10',url:require('../assets/images/frames/bjx/bjx_10.png')},
        {name:'bjx_11',url:require('../assets/images/frames/bjx/bjx_11.png')},
        {name:'bjx_12',url:require('../assets/images/frames/bjx/bjx_12.png')}
    ],
    bjx_d: [
        {name:'bjx_d_1',url:require('../assets/images/frames/bjx_d/bjx_d_1.png')},
        {name:'bjx_d_2',url:require('../assets/images/frames/bjx_d/bjx_d_2.png')},
        {name:'bjx_d_3',url:require('../assets/images/frames/bjx_d/bjx_d_3.png')},
        {name:'bjx_d_4',url:require('../assets/images/frames/bjx_d/bjx_d_4.png')},
        {name:'bjx_d_5',url:require('../assets/images/frames/bjx_d/bjx_d_5.png')},
        {name:'bjx_d_6',url:require('../assets/images/frames/bjx_d/bjx_d_6.png')},
        {name:'bjx_d_7',url:require('../assets/images/frames/bjx_d/bjx_d_7.png')},
        {name:'bjx_d_8',url:require('../assets/images/frames/bjx_d/bjx_d_8.png')},
        {name:'bjx_d_9',url:require('../assets/images/frames/bjx_d/bjx_d_9.png')},
        {name:'bjx_d_10',url:require('../assets/images/frames/bjx_d/bjx_d_10.png')},
        {name:'bjx_d_11',url:require('../assets/images/frames/bjx_d/bjx_d_11.png')},
        {name:'bjx_d_12',url:require('../assets/images/frames/bjx_d/bjx_d_12.png')}
    ],
    tjx:[
        {name:'tjx_1',url:require('../assets/images/frames/tjx/tjx_1.png')},
        {name:'tjx_2',url:require('../assets/images/frames/tjx/tjx_2.png')},
        {name:'tjx_3',url:require('../assets/images/frames/tjx/tjx_3.png')},
        {name:'tjx_4',url:require('../assets/images/frames/tjx/tjx_4.png')},
        {name:'tjx_5',url:require('../assets/images/frames/tjx/tjx_5.png')},
        {name:'tjx_6',url:require('../assets/images/frames/tjx/tjx_6.png')},
        {name:'tjx_7',url:require('../assets/images/frames/tjx/tjx_7.png')},
        {name:'tjx_8',url:require('../assets/images/frames/tjx/tjx_8.png')},
        {name:'tjx_9',url:require('../assets/images/frames/tjx/tjx_9.png')},
        {name:'tjx_10',url:require('../assets/images/frames/tjx/tjx_10.png')},
        {name:'tjx_11',url:require('../assets/images/frames/tjx/tjx_11.png')},
        {name:'tjx_12',url:require('../assets/images/frames/tjx/tjx_12.png')},
        {name:'tjx_13',url:require('../assets/images/frames/tjx/tjx_13.png')},
        {name:'tjx_14',url:require('../assets/images/frames/tjx/tjx_14.png')},
        {name:'tjx_15',url:require('../assets/images/frames/tjx/tjx_15.png')},
        {name:'tjx_16',url:require('../assets/images/frames/tjx/tjx_16.png')},
        {name:'tjx_17',url:require('../assets/images/frames/tjx/tjx_17.png')},
        {name:'tjx_18',url:require('../assets/images/frames/tjx/tjx_18.png')},
        {name:'tjx_19',url:require('../assets/images/frames/tjx/tjx_19.png')},
        {name:'tjx_20',url:require('../assets/images/frames/tjx/tjx_20.png')},
        {name:'tjx_21',url:require('../assets/images/frames/tjx/tjx_21.png')},
        {name:'tjx_22',url:require('../assets/images/frames/tjx/tjx_22.png')},
        {name:'tjx_23',url:require('../assets/images/frames/tjx/tjx_23.png')},
        {name:'tjx_24',url:require('../assets/images/frames/tjx/tjx_24.png')}
    ],
    tjx_d:[
        {name:'tjx_d_1',url:require('../assets/images/frames/tjx_d/tjx_d_1.png')},
        {name:'tjx_d_2',url:require('../assets/images/frames/tjx_d/tjx_d_2.png')},
        {name:'tjx_d_3',url:require('../assets/images/frames/tjx_d/tjx_d_3.png')},
        {name:'tjx_d_4',url:require('../assets/images/frames/tjx_d/tjx_d_4.png')},
        {name:'tjx_d_5',url:require('../assets/images/frames/tjx_d/tjx_d_5.png')},
        {name:'tjx_d_6',url:require('../assets/images/frames/tjx_d/tjx_d_6.png')},
        {name:'tjx_d_7',url:require('../assets/images/frames/tjx_d/tjx_d_7.png')},
        {name:'tjx_d_8',url:require('../assets/images/frames/tjx_d/tjx_d_8.png')},
        {name:'tjx_d_9',url:require('../assets/images/frames/tjx_d/tjx_d_9.png')},
        {name:'tjx_d_10',url:require('../assets/images/frames/tjx_d/tjx_d_10.png')},
        {name:'tjx_d_11',url:require('../assets/images/frames/tjx_d/tjx_d_11.png')},
        {name:'tjx_d_12',url:require('../assets/images/frames/tjx_d/tjx_d_12.png')},
        {name:'tjx_d_13',url:require('../assets/images/frames/tjx_d/tjx_d_13.png')},
        {name:'tjx_d_14',url:require('../assets/images/frames/tjx_d/tjx_d_14.png')},
        {name:'tjx_d_15',url:require('../assets/images/frames/tjx_d/tjx_d_15.png')},
        {name:'tjx_d_16',url:require('../assets/images/frames/tjx_d/tjx_d_16.png')},
        {name:'tjx_d_17',url:require('../assets/images/frames/tjx_d/tjx_d_17.png')},
        {name:'tjx_d_18',url:require('../assets/images/frames/tjx_d/tjx_d_18.png')},
        {name:'tjx_d_19',url:require('../assets/images/frames/tjx_d/tjx_d_19.png')},
        {name:'tjx_d_20',url:require('../assets/images/frames/tjx_d/tjx_d_20.png')},
        {name:'tjx_d_21',url:require('../assets/images/frames/tjx_d/tjx_d_21.png')},
        {name:'tjx_d_22',url:require('../assets/images/frames/tjx_d/tjx_d_22.png')},
        {name:'tjx_d_23',url:require('../assets/images/frames/tjx_d/tjx_d_23.png')},
        {name:'tjx_d_24',url:require('../assets/images/frames/tjx_d/tjx_d_24.png')}
    ]
}
